import { FormikTextField } from '@cmg/design-system-formik';

import { FormFieldLayout } from '../../../../../../design-system/body-sections/form/FormFieldLayout';
import { FormLayout } from '../../../../../../design-system/body-sections/form/FormLayout';
import { INVESTOR_FIRM_DETAIL_FIELD_LABELS } from '../models/InvestorFirmDetail.model';

type FirmDetailsFieldsProps = Readonly<{
  disableFirmKey?: boolean;
}>;

export function FirmDetailsFields({ disableFirmKey = false }: FirmDetailsFieldsProps) {
  return (
    <FormLayout>
      <FormFieldLayout>
        <FormikTextField
          name="firmKey"
          label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.firmKey}
          disabled={disableFirmKey}
          required
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="name" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.name} required />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="investorType"
          label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.investorType}
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="investorSubType"
          label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.investorSubType}
        />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="cik1" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.cik1} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="cik2" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.cik2} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="crd" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.crd} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="lei" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.lei} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField name="factSet" label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.factSet} />
      </FormFieldLayout>
      <FormFieldLayout>
        <FormikTextField
          name="description"
          multiline
          label={INVESTOR_FIRM_DETAIL_FIELD_LABELS.description}
          rows={3.5}
        />
      </FormFieldLayout>
    </FormLayout>
  );
}
